import { accountTransition } from '@Apis/accountTransition.api';

export type TransitionStatus = 'legacy' | 'new' | 'missing';

export type AccountTransitionGetRequest = {
	//
};
export type AccountTransitionGetResponse = {
	status: TransitionStatus;
};
export type AccountTransitionSetRequest = {
	status: TransitionStatus;
};
export type AccountTransitionSetResponse = {
	status: TransitionStatus;
};

const accTransEp = () => '/account/transition';

export const accountTransitionGet = () => {
	const endpoint = `${accTransEp()}`;
	return accountTransition.get<AccountTransitionGetResponse>(endpoint);
};

export const accountTransitionSet = (body: AccountTransitionSetRequest) => {
	const endpoint = `${accTransEp()}`;
	return accountTransition.post<AccountTransitionSetResponse>(endpoint, body);
};
